import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/';
import './registerServiceWorker';
// import { googleApiKey } from './config';

import vuetify from './plugins/vuetify';

import VueHead from 'vue-head'
import Meta from 'vue-meta'

Vue.use(Meta)
Vue.use(VueHead)
Vue.config.productionTip = false;

import moment from 'moment';
moment.locale('id');

import * as VueGoogleMaps from 'vue2-google-maps';
import GmapMarker from 'vue2-google-maps/src/components/marker';
Vue.component('GmapMarker', GmapMarker);
Vue.use(VueGoogleMaps, {
	installComponents: true,
	load: {
		key: process.env.VUE_APP_GOOGLE_MAP_KEY,
		libraries: 'places',
	}
})

// import * as VueGoogleMaps from 'vue2-google-maps';
// Vue.use(VueGoogleMaps, {
// 	load: {
// 		//   key: process.env.VUE_APP_GOOGLE_MAP_KEY,
// 		libraries: 'places',
// 	}
// });
// import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-2';

// Vue.use(TawkMessengerVue, {
//     propertyId : '64c8536894cf5d49dc67a2f6',
//     widgetId : '1h6n8bka3'
// });

import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer'
Vue.use(Viewer)


import daycount from '@/components/daycount';
Vue.component('daycount', daycount)

import modalcart from '@/views/store/cart/ModalCart'
Vue.component('modalcart', modalcart)

import VueContentLoading from 'vue-content-loading'
Vue.component('vcl', VueContentLoading);

import VCurrencyField from 'v-currency-field'

import { VTextField } from 'vuetify/lib'  //Globally import VTextField

Vue.component('v-text-field', VTextField)
import VueBarcode from '@chenfengyuan/vue-barcode';
Vue.component(VueBarcode.name, VueBarcode);

Vue.use(VCurrencyField, {
	locale: 'pt-BR',
	decimalLength: 0,
	autoDecimalMode: false,
	min: null,
	max: 99999999999,
	defaultValue: null,
	valueAsInteger: false,
	allowNegative: false
})

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app');

Vue.mixin({
	data: () => {
		return {
			today: moment(new Date()).format('YYYY-MM-DD'),
			search_text: '',
			limit: 1,
		}
	},
	methods: {
		convertDate(val) {
			if (Array.isArray(val)) {
				if (val.length > 0) {
					return val.map((el) => {
						return this.$options.filters.tanggal(el);
					})
				} else {
					return ''
				}
			} else {
				if (val) {
					return this.$options.filters.tanggal(val);
				} else {
					return ''
				}
			}
		},
		queryString(value) {
			let parameterObject = {}
			let parameter = '{'

			if (value.params) {
				value.params.forEach((value, index) => {
					for (const [key, val] of Object.entries(value)) {
						parameter += `"filter[${index}][${key}]":"${val}",`
					}
				})
			}
			parameter += `"limit": "${value.limit}", "page": "${value.page}", "sort": "${value.sort}", "dir": "${value.dir}"`
			parameter += '}'
			parameterObject = JSON.parse(parameter)
			return parameterObject
		},
		onlyNumber($event) {
			let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

			if ((keyCode < 48 || keyCode > 57) && keyCode !== 8) {
				$event.preventDefault();
			}
		},
		fullRating(rating) {
			return Math.floor(parseFloat(rating))
		},
		halfRating(rating, review_count) {
			return (parseFloat(rating) * 10) % parseFloat(review_count)
		},
		nullRating(rating) {
			return 5 - Math.ceil(parseFloat(rating))
		},
	},
	created() {
		if (this.$route) {
			if (this.$route.name == 'search-product') {
				if (this.$route.query.search) {
					this.search_text = this.$route.query.search.replace(/-/g, ' ')
				}
			}
		}
	},
	watch: {

	}
})

Vue.filter('tanggal', function (value) {
	var date = moment(value).format('DD MMMM YYYY')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('tanggalIndo', function (value) {
	var date = moment(value).format('DD-MM-YYYY')
	if (date == 'Invalid date' || !value) {
		return ''
	} else {
		return date
	}
});

Vue.filter('haritanggal', function (value) {
	var date = moment(value).format('dddd, DD MMMM YYYY')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('tanggaljam', function (value) {
	var date = moment(value).format('DD MMMM YYYY HH:mm:ss')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('haritanggaljam', function (value) {
	var date = moment(value).format('dddd, DD MMMM YYYY HH:mm:ss')
	if (date == 'Invalid date' || !value) {
		return '-'
	} else {
		return date
	}
});

Vue.filter('toNumber', function (value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});

	if (Number.isNaN(parseInt(value))) {
		return 0
	} else {
		return formatter.format(parseInt(value));
	}
});

Vue.filter('emptyData', function (value) {
	if (value === null || value === undefined || value === '') {
		return '-'
	} else {
		return value
	}
});

Vue.filter('toRupiah', function (value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});

	if (Number.isNaN(parseInt(value))) {
		return `Rp 0`
	} else {
		return `Rp ${formatter.format(parseInt(value))}`;
	}
});

Vue.filter('toKg', function (value) {
	var formatter = new Intl.NumberFormat('id', {
		minimumFractionDigits: 0
	});
	if (parseInt(value) >= 1000) {
		return formatter.format(parseInt(value) / 1000) + ' kg';
	} else {
		return formatter.format(parseInt(value)) + ' gr';
	}
});

Vue.filter('two_digits', (value) => {
	if (value < 0) {
		return '00';
	}
	if (value.toString().length <= 1) {
		return `0${value}`;
	}
	return value;
});

Vue.filter('toStatusMidtrans', (value) => {
	const status = {
		'capture': 'Lunas',
		'settlement': 'Lunas',
		'pending': 'Belum Dibayar',
		'cancel': 'Dibatalkan',
		'rejected': 'Ditolak Admin',
		'expired': 'Kedaluwarsa'
	}
	return status[value];
});

Vue.filter('toStatusTransaction', (value) => {
	const status = {
		'created': 'Menunggu Pembayaran',
		'pending': 'Menunggu Approval',
		'expired': 'Transaksi Kedaluwarsa',
		'cancel': 'Transaksi Dibatalkan',
		'paid': 'Menunggu Diproses Penjual',
		'processed': 'Diproses Penjual',
		'on_delivery': 'Proses Pengiriman',
		'completed': 'Selesai',
		'rejected_admin': 'Dibatalkan oleh Admin',
		'rejected_seller': 'Dibatalkan oleh Penjual'
	}
	return status[value];
});

Vue.filter('toIconTransaction', (value) => {
	const status = {
		'created': 'mdi-wallet-outline',
		'expired': 'mdi-timer-off-outline',
		'cancel': 'mdi-alert-circle-outline',
		'paid': 'mdi-archive-arrow-up-outline',
		'processed': 'mdi-package-variant',
		'on_delivery': 'mdi-truck-delivery-outline',
		'completed': 'mdi-check-circle-outline',
		'rejected_admin': 'mdi-alert-circle-outline',
		'rejected_seller': 'mdi-alert-circle-outline'
	}
	return status[value];
});

Vue.filter('toTypeTransaction', (value) => {
	const status = {
		'created': 'success',
		'expired': 'failed',
		'cancel': 'failed',
		'paid': 'success',
		'processed': 'success',
		'on_delivery': 'success',
		'completed': 'success',
		'rejected_admin': 'failed',
		'rejected_seller': 'failed'
	}
	return status[value];
});

Vue.filter('toNoteStock', value => {
	let note = 'Stok tersedia.'
	if (value <= 0) {
		note = 'Stok habis.'
	} else if (value <= 10) {
		note = 'Stok tinggal <10, beli segera!'
	} else if (value <= 20) {
		note = 'Stok tinggal <20, beli segera!'
	}
	return note
})

Vue.filter('internalType', value => {
	let type = value.type
	if (value.type == 'aktivasi_upgrade') {
		if (value.register == 'yes') {
			type = 'aktivasi'
		} else {
			type = 'upgrade'
		}
	}
	return type
})
